import {
  ImageOptionsKey,
} from '@bingads-webui-campaign-react/smart-component-image';

export const logoImageOptionsConfig = {
  [ImageOptionsKey.DEFAULT]: {
    text: _TL_('Use default'),
  },
  [ImageOptionsKey.FACEBOOKIMPORT]: {
    text: _TL_('Use profile picture from Facebook'),
  },
};
